/* url-validator.js */

"use strict";

/**
 * Validates if a URL is safe to store in localStorage.
 * Checks that the URL is well-formed and doesn't contain nested protocols or URLs in the pathname.
 *
 * @param {string} urlString - The URL string to validate
 * @returns {boolean} - True if the URL is valid and safe to store, false otherwise
 *
 * @example
 * isValidUrlForStorage("https://example.com/path") // true
 * isValidUrlForStorage("https://example.com/frontend/https:/example.com") // false
 */
function isValidUrlForStorage(urlString) {
    try {
        const url = new URL(urlString);
        // URL pathname should not contain protocols or nested URLs
        return !url.pathname.includes("://") && !url.pathname.includes("http");
    } catch (e) {
        return false;
    }
}

module.exports = {
    isValidUrlForStorage,
};
